var map = {
	"./admin.ts": 94,
	"./attach.ts": 137,
	"./config.ts": 110,
	"./dashboard.ts": 465,
	"./declare.ts": 138,
	"./edu.ts": 71,
	"./edumain.ts": 108,
	"./exam.ts": 27,
	"./form.ts": 171,
	"./license.ts": 160,
	"./log.ts": 198,
	"./login.ts": 86,
	"./phishing.ts": 113,
	"./quiz.ts": 186,
	"./register.ts": 181,
	"./share.ts": 184,
	"./startExam.ts": 95,
	"./tag.ts": 115,
	"./target.ts": 67,
	"./template.ts": 75,
	"./user.ts": 66
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1232;